/* ==========================================================================
 * at-cart-toast.js  (v3)
 * Po „Dodaj do koszyka": przejmujemy dodawanie i robimy je sami przez
 * /cart/add.js (razem z dopłatami), dzięki czemu SZUFLADA SIĘ NIE OTWIERA.
 * Zamiast niej pokazujemy mały dymek (toast) w prawym górnym rogu i od razu
 * odświeżamy licznik w ikonie koszyka.
 *
 * Dodatkowo: klik w ikonę koszyka prowadzi na stronę /cart (zawsze aktualna),
 * a nie otwiera nieodświeżonej szuflady — koniec rozjazdu licznik/zawartość.
 *
 * Ten plik musi ładować się PRZED at-pdp-custom.js.
 * ========================================================================== */
(function () {
  'use strict';

  var BASE = ((window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/').replace(/\/$/, '');
  var ADD_URL = BASE + '/cart/add.js';
  var CART_URL = BASE + '/cart.js';

  /* --------------------------------------------------------------- Toast UI */
  var toastEl, hideTimer;
  function ensureToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'at-cart-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    toastEl.innerHTML =
      '<span class="at-cart-toast__ic">✓</span>' +
      '<span class="at-cart-toast__txt"></span>' +
      '<a class="at-cart-toast__link" href="' + BASE + '/cart">Koszyk</a>';
    document.body.appendChild(toastEl);
    return toastEl;
  }
  function showToast(msg) {
    var t = ensureToast();
    t.querySelector('.at-cart-toast__txt').textContent = msg || 'Dodano do koszyka';
    t.classList.remove('is-show');
    void t.offsetHeight;
    t.classList.add('is-show');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { t.classList.remove('is-show'); }, 3000);
  }

  /* --------------------------------------------- Licznik w ikonie koszyka */
  function updateCount() {
    fetch(CART_URL, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = c.item_count || 0;
        var txt = n > 99 ? '99+' : String(n);
        document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
          var s = b.querySelector('span[aria-hidden="true"]');
          if (s) { s.textContent = txt; }
          if (n === 0) { b.setAttribute('data-empty', 'true'); }
          else { b.removeAttribute('data-empty'); }
        });
      })
      .catch(function () { /* no-op */ });
  }
  document.addEventListener('cart:refresh', updateCount);
  document.addEventListener('cart:build', updateCount);

  /* ------------------------------------------------------------ Dopłaty (add-ons) */
  function collectAddons(scope, qty, title) {
    var items = [];
    (scope || document).querySelectorAll('[data-addon][data-addon-variant]').forEach(function (grp) {
      var vid = grp.getAttribute('data-addon-variant');
      var yes = grp.querySelector('[data-addon-yes]');
      if (vid && /^\d+$/.test(vid) && yes && yes.checked) {
        items.push({ id: parseInt(vid, 10), quantity: qty, properties: { '_dopłata_do': title || '' } });
      }
    });
    return items;
  }

  /* ---------------------------------------------------- Przejęcie „Dodaj do koszyka" */
  var busy = false;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;

    e.preventDefault();
    e.stopImmediatePropagation(); // motyw NIE dodaje i NIE otwiera szuflady
    if (busy) return;

    var scope = form.closest('.product') || form.closest('[id^="MainProduct-"]') || document;
    var titleEl = scope.querySelector('.product__title');
    var title = titleEl ? titleEl.textContent.trim() : '';

    var fd = new FormData(form);
    var qty = parseInt(fd.get('quantity') || '1', 10);
    if (!(qty > 0)) qty = 1;

    var mainItem = { id: fd.get('id'), quantity: qty, properties: {} };
    fd.forEach(function (val, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m) mainItem.properties[m[1]] = val;
    });
    scope.querySelectorAll('input[type="radio"][name^="properties["]:checked').forEach(function (r) {
      var m = r.name.match(/^properties\[(.+)\]$/);
      if (m) mainItem.properties[m[1]] = r.value;
    });

    if (!mainItem.id) { return; }

    var items = [mainItem].concat(collectAddons(scope, qty, title));

    var btn = form.querySelector('[name="add"]');
    var spinner = btn ? btn.querySelector('.loading-overlay__spinner') : null;
    if (btn) { btn.setAttribute('aria-disabled', 'true'); }
    if (spinner) { spinner.classList.remove('hidden'); }

    busy = true;
    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          showToast((res.d && res.d.description) ? res.d.description : 'Nie udało się dodać');
        } else {
          updateCount();
          showToast('Dodano do koszyka');
        }
      })
      .catch(function () { showToast('Błąd dodawania do koszyka'); })
      .finally(function () {
        busy = false;
        if (btn) { btn.removeAttribute('aria-disabled'); }
        if (spinner) { spinner.classList.add('hidden'); }
      });
  }, true);

  /* ---------------------- Klik w ikonę koszyka → otwórz ŚWIEŻĄ szufladę */
  function openDrawer(d) {
    if (!d) { window.location.href = BASE + '/cart'; return; }
    try { if (typeof d.open === 'function') { d.open(); return; } } catch (e) { /* no-op */ }
    d.classList.add('animate', 'active');
    d.setAttribute('open', '');
  }
  function openFreshDrawer() {
    var current = document.querySelector('cart-drawer');
    fetch(window.location.pathname + (window.location.search || ''), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('cart-drawer');
          if (fresh && current && current.parentNode) {
            current.replaceWith(fresh);
            current = fresh;
          }
        } catch (e) { /* no-op */ }
        openDrawer(current);
      })
      .catch(function () { openDrawer(current); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var link = e.target.closest('#cart-icon-bubble, .header__icon--cart');
    if (!link) return;
    e.preventDefault();
    e.stopImmediatePropagation(); // nie pozwól motywowi otworzyć starej (nieaktualnej) szuflady
    openFreshDrawer();
  }, true);
})();
